import {
  combineAllReviews,
  reviewRatingMean,
} from '../../common/helpers/common-helpers';

export const selectDataClinic = (state) => state.data.clinic;

export const selectDataClinicAddress = (state) => state.data.clinic.address;

export const selectDataClinicDescription = (state) =>
  state.data.clinic.description;

export const selectDataClinicQuestionResponses = (state) =>
  state.data.clinic.questionResponses;

export const selectDataClinicSuperPracticeBadges = (state) =>
  state.data.clinic.superPracticeBadges;

export const selectDataClinicAverageRating = (state) => {
  const reviews = combineAllReviews(state.data.clinic);

  return reviewRatingMean(reviews);
};

export const selectDataClinicBookedByPastMonth = (state) =>
  state.data.clinic.bookedByPastMonth;

export const selectDataClinicExternalReviews = (state) =>
  state.data.clinic.externalReviewData;

export const selectDataClinicFeatures = (state) => state.data.clinic.features;

export const selectDataClinicSafetyProcedures = (state) =>
  state.data.clinic.covidSafetyProceduresMap;

export const selectDataClinicHours = (state) => state.data.clinic.hours;

export const selectDataClinicId = (state) => state.data.clinic.id;

export const selectDataClinicName = (state) => state.data.clinic.name;

export const selectDataClinicPhotos = (state) => state.data.clinic.photos;

export const selectDataClinicProviders = (state) => state.data.clinic.providers;

export const selectDataClinicSlots = (state) => state.data.clinic.slots;

export const selectDataClinicIsInstantBook = (state) =>
  state.data.clinic.isInstantBook;

export const selectDataClinicWebsite = (state) => state.data.clinic.website;

export const selectDataClinicPerformanceBadges = (state) =>
  state.data.clinicPerformanceBadges;

export const selectDataMatchOther = (state) => state.data.match?.other;
